import { Effect } from 'effect';

import subscribeNewsletter from '../../flow/customer/subscribeNewsletter';
import { RuntimeClientAtom } from '@vs-shop/engine/runtime/RuntimeClient';

export const subscribeNewsletterAtomFn = RuntimeClientAtom.fn(
  Effect.fnUntraced(function* (email: string) {
    return yield* subscribeNewsletter(email);
  })
);
